import React, { useState } from "react";
import "../../css/pages/services.css";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import imageOne from "../../assets/images/EquityRelease2.jpg";
import imageTwo from "../../assets/images/EquityRelease3.jpg";
import imageThree from "../../assets/images/EquityRelease4.jpg";
import imageFour from "../../assets/images/EquityRelease5.jpg";
import Hero from "../designSystem/Hero";
import HeroImage from "../../assets/images/EquityRelease1.jpg";
import ContactUsPage from "./ContactUsPage";

const equityReleaseData = [
  {
    title: "Equity Release",
    subtitle: "Unlocking Property Wealth",
    description:
      "Your home is often your largest asset, yet much of its value remains tied up. Equity release allows you to access part of that wealth without moving, giving you greater financial flexibility while continuing to live in your home. We help you decide if it is right for you, ensuring it supports your long term plans and lifestyle.",
    image: imageOne,
  },
  {
    title: "Equity Release",
    subtitle: "Understanding Your Options",
    description:
      "There are different types of equity release, including lifetime mortgages and home reversion plans. We provide clear, straightforward guidance on how each option works, helping you make an informed decision with confidence and clarity.",
    image: imageTwo,
  },
  {
    title: "Equity Release",
    subtitle: "Supporting Your Retirement",
    description:
      "vFor many, equity release can provide additional funds to support later life, whether that means supplementing income, funding home improvements, or helping family members. Any solution we recommend is carefully aligned with your broader retirement goals and financial strategy.",
    image: imageThree,
  },
  {
    title: "Equity Release",
    subtitle: "Carefully Considered",
    description:
      "Equity release is not a one size fits all solution and has long term implications for your estate and finances. We take a holistic approach, ensuring it fits alongside your pensions, investments and plans, while clearly explaining the benefits and risks so any recommendation suits your needs and circumstances.",
    image: imageFour,
  },
];

const EquityReleasePage = () => {
  // State to track which descriptions are shown
  const [showDescriptions, setShowDescriptions] = useState(
    equityReleaseData.map(() => true),
  );

  // Handler to toggle description visibility for a card
  const handleSeeMoreClick = (idx) => {
    setShowDescriptions((prev) =>
      prev.map((shown, i) => (i === idx ? !shown : shown)),
    );
  };

  return (
    <div className="home-page about-page">
      <Hero
        title="Trusted equity release advice for later life"
        subtitle="Equity release"
        primary={true}
        backgroundImage={HeroImage}
        titleAlign="center"
        subtitleAlign="center"
      />

      <section className="page-section">
        <div className="page-section-inner">
          <div className="page-card-grid">
            {equityReleaseData.map((equityRelease, index) => (
              <div className="page-card" key={index}>
                <div className="page-card-image">
                  <img src={equityRelease.image} alt={equityRelease.title} />
                </div>

                <div className="page-card-content">
                  <div className="nav primary">{equityRelease.title}</div>
                  <h2 className="primary">
                    {equityRelease.subtitle.split(" ")[0]}{" "}
                    <span className="italic-text">
                      {equityRelease.subtitle.split(" ")[1]}{" "}
                      {equityRelease.subtitle.split(" ")[2]}{" "}
                      {equityRelease.subtitle.split(" ")[3]}
                    </span>
                  </h2>
                  {showDescriptions[index] && (
                    <div className="content primary">
                      {equityRelease.description}
                    </div>
                  )}

                  <SeeMoreButton onClick={() => handleSeeMoreClick(index)}>
                    {showDescriptions[index] ? "See Less" : "See More"}
                  </SeeMoreButton>
                </div>
              </div>
            ))}
          </div>
          <div
            className="content-semibold primary"
            style={{ textAlign: "center", marginTop: "40px" }}
          >
            Our role is to bring clarity, structure, and confidence, so you can
            move forward knowing you have explored all options with care.
          </div>
        </div>
      </section>
      <section className="investment-note-section">
        <div className="home-container investment-note body">
          <strong>Please Note:</strong> Equity release will reduce the value of
          your estate and can affect your eligibility for means tested benefits.
        </div>
      </section>
      <ContactUsPage />
    </div>
  );
};

export default EquityReleasePage;
